<style lang="stylus">
    .ed-slider
        display flex
        flex-direction column
        justify-content space-between
        width 200px
        height 100%
        flex-shrink 0
        border-right 1px solid rgba(0, 0, 0, 0.08)
        background #fff
        z-index 11
        .slider-icon
            display flex
            align-items center
            height 56px
            padding 0 16px
            cursor pointer
        .slider-newbox
            position relative
            margin 16px
            margin-top 24px
            width calc(100% - 32px)

            .slider-newbtn
                display flex
                justify-content center
                align-items center
                height 40px
                width 100%
                background #017FFF
                border-radius 6px
                user-select none
                cursor pointer
                >img
                    width 24px
                    height 24px
                    margin-right 8px
                >p
                    font-size 14px
                    line-height 18px
                    color #fff
            .slider-newbtn-model
                position absolute
                left 0
                top 48px
                padding 16px 0
                min-width 320px
                min-height 434px
                background #fff
                box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05), 0px 2px 10px 0px rgba(0, 0, 0, 0.08)
                border-radius 8px
                z-index 10
                .newbtn-modal-split
                    height 1px
                    margin 8px 16px
                    background rgba(0, 0, 0, 0.08)
                    &.newbtn-modal-split-full
                        margin 16px 0
                .newbtn-model-rowtitle
                    width 100%
                    text-align center
                    font-size 12px
                    line-height 16px
                    color rgba(34, 34, 34, 0.40)
                    margin-bottom 12px
                    user-select none
                .newbtn-model-row
                    display flex
                    row-gap 8px
                    column-gap 8px
                    flex-wrap wrap
                    margin 0 16px
                    .newbtn-model-block
                        display flex
                        flex-direction column
                        width 88px
                        height 80px
                        align-items center
                        padding-top 12px
                        user-select none
                        cursor pointer
                        border-radius 6px
                        &:hover
                            background rgba(242, 244, 249, 0.60)
                        img
                            width 32px
                            height 32px
                            margin-bottom 8px
                        p
                            font-size 12px
                            line-height 16px
                            color #222
                            max-width 100%
                            textOverflow()
                .newbtn-model-extrarow
                    display flex
                    flex-wrap wrap
                    row-gap 12px
                    column-gap 12px
                    margin 0 16px
                    .newbtn-model-smallblock
                        display flex
                        flex-direction column
                        width 88px
                        height 72px
                        align-items center
                        padding-top 12px
                        user-select none
                        cursor pointer
                        border-radius 6px
                        &:hover
                            background rgba(242, 244, 249, 0.60)
                        img
                            width 24px
                            height 24px
                            margin-bottom 8px
                        p
                            font-size 12px
                            line-height 16px
                            color #222
                            max-width 100%
                            textOverflow()

        .slider-list
            flex 1
            overflow-y auto
            width 100%
            padding 0 16px 16px 16px
            &::-webkit-scrollbar
                width 8px
                pointer-events none
                background none
            &::-webkit-scrollbar-thumb
                display none
                background #D2D3D6
                border-radius 4px
                border 1px solid #fff
            &::-webkit-scrollbar-track
                background #fff
            &::-webkit-scrollbar-track-piece
                background none
            &::-webkit-scrollbar-corner
                background none
            &:hover
                &::-webkit-scrollbar-thumb
                    display block
            .slider-item
                width 100%
                height 40px
                padding 0 16px
                display flex
                align-items center
                border-radius 6px
                cursor pointer
                position relative
                .arrow
                    display none
                    width 16px
                    height 16px
                    position absolute
                    right: 0px
                    transform rotate(-90deg)
                .blue-arrow
                    display block
                    transform rotate(0deg)
                .active-default-arrow
                    display block
                    transform rotate(0deg)

                &:hover
                    .default-arrow,.active-blue-arrow
                        display block


                &:not(:last-child)
                    margin-bottom 2px
                img
                    width 24px
                    height 24px
                    margin-right 8px
                p
                    font-size 14px
                    line-height 18px
                    color #000
                    user-select none
                    textOverflow()
                .name-tag
                    display inline-block
                    color #fff
                    width 16px
                    height 16px
                    line-height 17px
                    text-align center
                    margin 8px
                    margin-right 16px
                    border-radius 2px
                    font-size 13px
                    margin-left 4px
                .name-content
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    max-width 100px
                &:hover
                    background rgba(1, 127, 255, 0.08)
                &.active
                    background rgba(1, 127, 255, 0.08)
                    p
                        color #017fff
            .slider-split
                width 100%
                height 1px
                background rgba(0, 0, 0, 0.08)
                margin 8px 0
                pointer-events none
            .team-list
                .slider-item.active
                    background rgba(1, 127, 255, 0.08)
                    p
                        color #017fff
        .slider-nalpromo
            display flex
            padding 16px
            cursor pointer
            img
                border-radius 8px
</style>

<template>
    <div class="ed-slider" @click="clear">
        <div class="slider-icon" @click="tohome">
            <a :href="homeUrl" @click.prevent="handleEmpty">
                <span style="display: none">{{ homeText }}</span>
                <img :src="icon" alt="" />
            </a>
        </div>

        <div class="slider-newbox" v-click-outside="closeNewModal">
            <div class="slider-newbtn" @click="expandNewModal">
                <img src="@/home/assets/onlineview/sliderIcon/slider-new.svg" alt="" />
                <p>{{ $t("new") }}</p>
            </div>

            <div class="slider-newbtn-model" v-if="showNewModal">
                <ul class="newbtn-model-row">
                    <li class="newbtn-model-block" v-for="(item, index) in newMenu" :key="index" @click="addNewPage(item.label)">
                        <img :src="require(`@/home/assets/onlineview/sliderIcon/new-${item.label}.svg`)" alt="" />
                        <p :title="$t(item.label)">{{ $t(item.label) }}</p>
                    </li>
                </ul>

                <div class="newbtn-modal-split"></div>

                <ul class="newbtn-model-row">
                    <li class="newbtn-model-block" v-for="(item, index) in existMenu" :key="index" @click="clickExist(item.id)">
                        <img :src="require(`@/home/assets/onlineview/sliderIcon/exist-${item.label}.svg`)" alt="" />
                        <p :title="$t(item.label)">{{ $t(item.label) }}</p>
                    </li>
                </ul>

                <div class="newbtn-modal-split newbtn-modal-split-full"></div>

                <div class="newbtn-model-rowtitle">{{ $t("moreTool") }}</div>
                <ul class="newbtn-model-extrarow">
                    <li class="newbtn-model-smallblock" v-for="(item, index) in moreMenu" :key="index" @click="clickMore(item.label)">
                        <img :src="require(`@/home/assets/onlineview/sliderIcon/more-${item.label}.svg`)" alt="" />
                        <p :title="$t(item.label)">{{ $t(item.label) }}</p>
                    </li>
                </ul>
            </div>
        </div>

        <div class="slider-list">
            <template v-for="(item, index) in sliderList">
                <template v-if="item.type == 'item'">
                    <div
                        :key="index"
                        class="slider-item"
                        :class="{
                            active: selectId == item.id && !selectTeamId,
                        }"
                        @click="clickSlider(item.id)"
                    >
                        <img :src="require(`@/home/assets/onlineview/sliderIcon/${item.label}${selectId == item.id ? '-active' : ''}.svg`)" alt="" />
                        <p>{{ $t(item.label) }}</p>
                        <template v-if="item.id === 21 && teams && teams.length > 0">
                            <img
                                class="arrow"
                                :class="showTeamList ? (selectTeamId ? '' : 'blue-arrow') : 'active-blue-arrow'"
                                :src="require('@/home/assets/img/team/team-blue-arrow.svg')"
                                alt=""
                            />
                            <img
                                class="arrow"
                                :class="{
                                    'default-arrow': selectId !== 21 && !showTeamList,
                                    'active-default-arrow': selectId === 21 && selectTeamId,
                                }"
                                :src="require('@/home/assets/img/team/team-default-arrow.svg')"
                                alt=""
                            />
                        </template>
                    </div>
                </template>
                <template v-else>
                    <div class="slider-split" :key="index"></div>
                </template>
                <template v-if="item.id === 21 && showTeamList">
                    <div class="team-list" :key="index" v-if="teams.length > 0">
                        <div
                            class="slider-item"
                            :class="selectTeamId === team.id ? 'active' : ''"
                            v-for="(team, index) in teams"
                            :key="index"
                            @click="clickTeamItem(team)"
                            :index="index"
                            :item="item"
                            @contextmenu.prevent.stop="contextmenu($event, team)"
                        >
                            <span class="name-tag" :style="`background:${colors[index % 6]}`">{{ team.name[0] }}</span>
                            <p :title="team.name" class="name-content">{{ $t(team.name) }}</p>
                        </div>
                    </div>
                </template>
            </template>
        </div>

        <Modal v-model="uploadState" :title="$t('importSuccess')" @on-ok="asyncOK">
            <p>{{ $t("isOpen") }}</p>
        </Modal>
        <input id="inputFile" type="file" accept=".eddx" style="display: none" @change="getFile($event.target.files[0])" />
        <RightMenu
            v-if="contextmenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="rightmenuList"
            @handleClicks="handleClick($event)"
        />
        <!-- bus事件 -->
        <ShortcutBox v-show="false"></ShortcutBox>
        <div class="slider-nalpromo" v-if="nalPromoData && nalPromoData.img" @click="clickNalPromo">
            <img :src="nalPromoData.img" :style="{ width: `${nalPromoData.w}px`, height: `${nalPromoData.h}px` }" alt="" />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import ShortcutBox from "@/public/components/ShortcutBox.vue";
    import RightMenu from "../RightMenu.vue";
    import { setDefaultLibs, openNewTab } from "@/public/utils/tool";
    @Component({
        components: {
            RightMenu,
            ShortcutBox,
        },
    })
    export default class SliderOnline extends Vue {
        get sliderList() {
            let arr = [
                {
                    id: 0,
                    label: "newPage",
                    type: "item",
                },
                {
                    id: 20,
                    label: "openrecord",
                    type: "item",
                },
                {
                    id: 1,
                    label: "cloud",
                    type: "item",
                },
                {
                    id: 22,
                    label: "sharetome",
                    type: "item",
                },
                {
                    id: -1,
                    label: "",
                    type: "line",
                },
                {
                    id: 21,
                    label: "team",
                    type: "item",
                },
                {
                    id: -1,
                    label: "",
                    type: "line",
                },
                {
                    id: 3,
                    label: "store",
                    type: "item",
                },
                {
                    id: 4,
                    label: "collect",
                    type: "item",
                },
                {
                    id: 15,
                    label: "course",
                    type: "item",
                },
            ];
            return this.internal ? arr : arr.filter((item) => item.id != 15);
        }
        newMenu = [
            {
                id: 0,
                label: "empty",
            },
            {
                id: 1,
                label: "flow",
            },
            {
                id: 2,
                label: "gantt",
            },
            {
                id: 3,
                label: "uml",
            },
            {
                id: 4,
                label: "plan",
            },
            {
                id: 5,
                label: "org",
            },
        ];
        existMenu = [
            {
                id: 0,
                label: "import",
            },
            {
                id: 1,
                label: "personal",
            },
        ];
        moreMenu = [
            {
                id: 0,
                label: "max",
            },
            {
                id: 1,
                label: "master",
            },
            {
                id: 2,
                label: "project",
            },
            {
                id: 3,
                label: "board",
            },
            {
                id: 4,
                label: "md",
            },
        ];

        get homeUrl() {
            return `/online/${this.lang}/`;
        }

        get homeText() {
            return this.lang === "zh" ? "亿图图示" : "EdrawMax";
        }

        get icon() {
            return require(`@/home/assets/onlineview/sliderIcon/slider-icon${this.lang != "zh" ? "-en" : ""}.svg`);
        }
        get rightmenuList() {
            let list = [
                { key: 0, label: this.$t("rename") },
                {
                    key: 1,
                    label: this.$t("memberManage"),
                    hide: !this.isPC,
                },
                {
                    key: 2,
                    type: "splitLine",
                },
                { key: 3, label: this.$t("deleteSpace") },
            ];
            if (this.selectTeam.role <= 2) {
                list = [
                    {
                        key: 0,
                        label: this.$t("memberManage"),
                        hide: !this.isPC,
                    },
                ];
            }
            if (this.selectTeam.role === 3) {
                list = [
                    // { key: 0, label: "重命名" },
                    {
                        key: 0,
                        label: this.$t("memberManage"),
                        hide: !this.isPC,
                    },
                ];
            }
            return list;
        }

        get userInfo() {
            return this.$store.state.userInfo;
        }

        get nalPromoData() {
            return this.$store.state.publicStore.nalPromo_slider;
        }

        clickNalPromo() {
            const url = this.nalPromoData.url;
            if (url) {
                const split = /\?/.test(url) ? "&" : "?";
                let params = `${split}custom=${encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.user_id, token: this.userInfo.token })))}`;
                window.open(`${url}${params}`);
            } else {
                this.$openBuyPage("nalPromo_topbar");
            }
        }

        trackMap = {
            empty: "new_blank_file",
            flow: "flow_chart",
            gantt: "gantt_chart",
            uml: "uml_diagram",
            plan: "house_floor_plan",
            org: "architecture_diagram",
            "0": "import",
            "1": "personal_template",
            master: "edrawmind",
            project: "edrawproj",
            board: "boardmix",
            md: "modao",
            max: "max",
        };

        handleEmpty() {}

        expandNewModal() {
            this.showNewModal = true;
            this.sensors.track("createbutton", {
                Catalogues: "myworkspace",
            });
        }
        trackNewModal(key: string) {
            this.sensors.track("creategridbutton", {
                Catalogues: "myworkspace",
                button_type: this.trackMap[key],
            });
        }

        handleClick(index) {
            let clickEvents = new Map([
                [
                    0,
                    () => {
                        if (this.selectTeam.id) {
                            this.$store.commit("toCurTeamId", this.selectTeam.id);
                            this.$bus.$emit("changeTeamName", this.selectTeam);
                        }
                    },
                ],
                [
                    1,
                    () => {
                        if (this.selectTeam.id) {
                            this.$store.commit("toCurTeamId", this.selectTeam.id);
                            this.$bus.$emit("showMember", this.selectTeam);
                        }
                    },
                ],
                [
                    3,
                    () => {
                        if (this.selectTeam.id) {
                            this.$store.commit("toCurTeamId", this.selectTeam.id);
                            this.$bus.$emit("deleteTeam", this.selectTeam);
                        }
                    },
                ],
            ]);
            if (this.selectTeam.role <= 2) {
                clickEvents = new Map([
                    [
                        0,
                        () => {
                            if (this.selectTeam.id) {
                                this.$store.commit("toCurTeamId", this.selectTeam.id);
                                this.$bus.$emit("showMember", this.selectTeam);
                            }
                        },
                    ],
                ]);
            }
            if (this.selectTeam.role === 3) {
                clickEvents = new Map([
                    // [
                    //     0,
                    //     () => {
                    //         if (this.selectTeam.id) {
                    //             this.$store.commit("toCurTeamId", this.selectTeam.id);
                    //             this.$bus.$emit("changeTeamName",this.selectTeam)
                    //         }
                    //     },
                    // ],
                    [
                        0,
                        () => {
                            if (this.selectTeam.id) {
                                this.$store.commit("toCurTeamId", this.selectTeam.id);
                                this.$bus.$emit("showMember", this.selectTeam);
                            }
                        },
                    ],
                ]);
            }
            const onClicks = clickEvents.get(index);
            onClicks && onClicks();
            this.clear();
        }

        clear() {
            this.contextmenuBoxShow = false;
        }

        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        get contextmenuBoxShow() {
            return this.$store.state.teamContextShow;
        }

        set contextmenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "teamContextShow",
                data: v,
            });
        }
        selectTeam = {
            id: "",
            name: "",
            role: 0,
        };
        contextmenu(e, item) {
            this.selectTeam = item;
            this.selectTeamId = item.id;
            this.top = e.pageY;
            this.left = e.pageX;
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.top -= 76;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.left -= 117;
            }
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: false,
            });
            this.contextmenuBoxShow = true;
        }

        showNewModal = false;
        closeNewModal() {
            this.showNewModal = false;
        }
        addNewPage(libType) {
            if (!this.$validateLogin()) {
                return;
            }
            let maxAction = this.$store.state.appState;
            let typeTrack = "default";
            if (maxAction) {
                if (maxAction == "create") this.$edMessage.success(this.$t("create"));
                return;
            }
            this.trackNewModal(libType);

            setDefaultLibs(libType);

            let newTab: any;
            let newTabCallback;
            let cancelOpen;
            if (!this.openInTabs) {
                // newTab = window.open(`${window.location.origin}${appConfig["sourcePath"]}app.html`, "");
                let task = openNewTab(`${window.location.origin}${appConfig["sourcePath"]}app.html`, this.$edMessage.destroy);
                newTabCallback = task.openTab;
                cancelOpen = task.cancelOpen;
                this.$edMessage.info(this.$tc("newPageCreateFile"), 0);
            }

            let limitCallback = (type = "") => {
                newTab && newTab.close();
                cancelOpen && cancelOpen();
                this.$edMessage.destroy();
                if (type == "showLimitModal") {
                    this.$bus.$on("limitModalContinue", () => {
                        console.log("on event");
                        this.$bus.$off("limitModalContinue");
                        this.addNewPage(libType);
                    });
                    this.$store.commit("setState", {
                        type: "showLimitFileModal",
                        data: true,
                    });
                } else if (type == "showLimitCloudSpaceVIP") {
                    this.$checkAuth({
                        type: "cloudSpaceVIP",
                        buyTrigger: "cloudSpacePop",
                        pcParams: { newUpgrade: 6, upgrade: 0 },
                    });
                } else if (type == "showLimitCloudSpace") {
                    this.$checkAuth({
                        type: "cloudSpace",
                        buyTrigger: "cloudSpacePop",
                        pcParams: { newUpgrade: 6, upgrade: 0 },
                    });
                } else {
                    this.$store.commit("toPublicStatus", {
                        type: "showUpgrade",
                        data: "fileNum",
                    });
                }
            };

            let enterCanvasTrack = `&file_source=emptyFile&template_type=noTemplate&diagram_type=${typeTrack}&fromNull=1`;
            let trackSuffix = "";
            trackSuffix += enterCanvasTrack;
            this.$openFile({
                params: {
                    newFileName: this.$t("newFile"),
                    libs: JSON.parse(localStorage.getItem("libs") || "[]"),
                },
                fileType: "emptyFile",
                suffix: trackSuffix,
                checkLimit: true,
                limitRange: this.$store.state.publicStore.runPlatform,
                limitCallback: limitCallback,
                vip: this.vip,
                from: "home",
                isFullCouldSpace: this.isFullCouldSpace,
            })
                .then((obj) => {
                    this.$bus.$emit("refreshList");
                    if (this.openInTabs) {
                        location.href = obj.url;
                    } else {
                        this.$edMessage.destroy();
                        newTab = newTabCallback(obj.url);
                    }
                    this.sensors.track("newFile", {
                        Catalogues: "openFileProcess",
                        new_file_way: "naviNewGridBtn",
                        new_file_type: "emptyFile",
                    });
                    this.$store.commit("setAppState", "create");
                    let timer = setInterval(() => {
                        try {
                            newTab.name;
                            newTab.name = obj.obj;
                            if (!newTab.name) {
                                this.$store.commit("setAppState", "");
                                clearInterval(timer);
                            }
                            if (!newTab.location.hash) {
                                this.$store.commit("setAppState", "");
                                clearInterval(timer);
                            }
                        } finally {
                        }
                    }, 1000);

                    // add open record
                    let key = obj.obj;
                    let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                    if (!openTabs.includes(key)) {
                        openTabs.push(key);
                    }
                    this.$store.commit("addWin", newTab);
                    localStorage.setItem("openTabs", JSON.stringify(openTabs));
                })
                .catch((err) => {});
            this.closeNewModal();
        }
        uploadState = false;
        uploadFilePath = "";
        set showImportModal(v) {
            this.$store.commit("setState", {
                type: "showImportModal",
                data: v,
            });
        }
        get showImportModal() {
            return this.$store.state.showImportModal;
        }
        asyncOK() {
            let ts: any = this;
            let maxAction = this.$store.state.appState;
            if (maxAction) {
                if (maxAction == "create") (<any>this).$edMessage.success(this.$t("create"));
                return;
            }
            if (this.openInTabs) {
                location.href =
                    window.location.origin + (<any>this.$router).options.base + "app.html?" + ts.$zipFileName("obj=" + this.uploadFilePath);
            } else {
                let fileObj = "obj=" + this.uploadFilePath;
                fileObj += "&file_source=importFile";
                window.open(window.location.origin + (<any>this.$router).options.base + "app.html?" + ts.$zipFileName(fileObj), this.uploadFilePath);
            }
            let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
            if (!openTabs.includes(this.uploadFilePath)) {
                openTabs.push(this.uploadFilePath);
            }
            localStorage.setItem("openTabs", JSON.stringify(openTabs));
        }
        getFile(file) {
            if (!this.$validateLogin()) {
                return;
            }
            if (!file.name.endsWith("eddx")) {
                this.$edMessage.error(this.$t("notSupportFile"));
                return;
            }
            this.$store.commit("setState", { data: true, type: "showLoading" });
            let name = file.name.match(/(.*)\.eddx/i) && file.name.match(/(.*)\.eddx/i)[1];
            let list = [];
            this.$store.dispatch("getFloder", { prefix: "" }).then((res) => {
                let filesList = res.data.data.files || [];
                filesList.map((item) => {
                    let list = item.key.split("/");
                    let n = list[list.length - 1];
                    n = n.match(/(.*)\.eddx/) && n.match(/(.*)\.eddx/)[1];
                    item.name = n;
                });
                filesList = filesList.filter((item) => {
                    if (item.key.match(/.+eddx$/)) {
                        return true;
                    }
                    return false;
                });
                filesList.forEach((fileItem) => {
                    let data = fileItem.name && fileItem.name.startsWith(name);
                    if (data) {
                        let res = fileItem.name.slice(name.length);
                        res = Number(res);
                        if (Number.isInteger(res)) {
                            list.push(res);
                        }
                    }
                });
                list = list.sort((a, b) => a - b);
                if (list.includes(0)) {
                    (<any>this).$Modal.confirm({
                        title: this.$t("cover"),
                        content: this.$t("isCover"),
                        okText: this.$t("confirm"),
                        cancelText: this.$t("cancel"),
                        onOk: () => {
                            this.$store
                                .dispatch("uploadFile", { file, name: name + ".eddx" })
                                .then((res) => {
                                    this.uploadFilePath = res.path;
                                    this.uploadState = true;
                                    this.$store.commit("setState", {
                                        data: false,
                                        type: "showLoading",
                                    });
                                })
                                .catch((err) => {
                                    console.log(err);
                                    if (err == "storage space not enough") {
                                        (<any>this).$edMessage.error(this.$t("space"));
                                    } else if (err !== "overLimit") {
                                        (<any>this).$edMessage.error(this.$t("uploadFail"));
                                    }
                                    this.$store.commit("setState", {
                                        data: false,
                                        type: "showLoading",
                                    });
                                });
                        },
                        onCancel: () => {
                            for (let i = 0; i < list.length; i++) {
                                if (list[i] + 1 != list[i + 1]) {
                                    name = file.name.match(/(.*)\.eddx/) && file.name.match(/(.*)\.eddx/)[1] + (list[i] + 1);
                                    break;
                                }
                            }
                            this.$store
                                .dispatch("uploadFile", { file, name: name + ".eddx" })
                                .then((res) => {
                                    this.uploadFilePath = res.path;
                                    this.uploadState = true;
                                    this.$store.commit("setState", {
                                        data: false,
                                        type: "showLoading",
                                    });
                                })
                                .catch((err) => {
                                    console.log(err);
                                    if (err == "storage space not enough") {
                                        (<any>this).$edMessage.error(this.$t("space"));
                                    } else if (err !== "overLimit") {
                                        (<any>this).$edMessage.error(this.$t("uploadFail"));
                                    }
                                    this.$store.commit("setState", {
                                        data: false,
                                        type: "showLoading",
                                    });
                                });
                        },
                    });
                } else {
                    this.$store
                        .dispatch("uploadFile", { file, name: name + ".eddx" })
                        .then((res) => {
                            this.uploadFilePath = res.path;
                            this.uploadState = true;
                            this.$store.commit("setState", {
                                data: false,
                                type: "showLoading",
                            });
                            this.sensors.track("generateCloudFile", {
                                Catalogues: "openFileProcess",
                                file_source: "importFile",
                            });
                        })
                        .catch((err) => {
                            console.log(err);
                            if (err == "storage space not enough") {
                                (<any>this).$edMessage.error(this.$t("space"));
                            } else if (err == "overLimit") {
                                (<any>this).$edMessage.error(this.$t("importOverLimit"));
                            } else if (err !== "overLimit") {
                                (<any>this).$edMessage.error(this.$t("uploadFail"));
                            }
                            this.$store.commit("setState", {
                                data: false,
                                type: "showLoading",
                            });
                        });
                }
                console.log(name);
                document.getElementById("inputFile")["value"] = "";
            });
        }
        clickExist(id) {
            if (id == 0) {
                this.trackNewModal("0");
                // import
                this.sensors.track("importButton", {
                    Catalogues: "openFileProcess",
                    click_source: "navi",
                });
                this.showImportModal = true;
            } else {
                this.trackNewModal("1");
                // jump to personal template
                this.$store.commit("setDialogState", {
                    type: "showDialog",
                    data: true,
                });
                this.$store.commit("setDialogState", {
                    type: "dialogType",
                    data: "TemplateModal",
                });
            }
            this.closeNewModal();
        }
        clickMore(label) {
            this.trackNewModal(label);
            this.openLink(label);
            this.closeNewModal();
        }
        openLink(type) {
            let url = "";
            switch (type) {
                case "max": {
                    if (this.internal) {
                        url = "https://www.edrawsoft.cn/edrawmax/?channel=max_new";
                    } else {
                        url = `https://www.edrawsoft.com/edraw-max/?channel=max_new`;
                    }
                    break;
                }
                case "master":
                    if (this.internal) {
                        url = "https://mm.edrawsoft.cn/?channel=max_new";
                    } else if (["en", "kr", "it", "pt"].includes(this.lang)) {
                        url = "https://www.edrawmind.com/?channel=max_new";
                    } else if (this.lang == "jp") {
                        url = "https://edrawsoft.com/jp/edrawmind/?channel=max_new";
                    } else if (this.lang == "tw") {
                        url = "https://www.edrawmind.com/zh-tw/?channel=max_new";
                    } else {
                        url = `https://www.edrawmind.com/${this.lang}/?channel=max_new`;
                    }
                    break;
                case "project":
                    let channel = "max_new";
                    if (this.internal) {
                        url = "https://www.edrawsoft.cn/edrawproject/?channel=" + channel;
                    } else if (["it", "fr", "pt", "de", "es"].includes(this.lang)) {
                        url = `https://www.edrawsoft.com/${this.lang}/edraw-project/?channel=${channel}`;
                    } else if (this.lang == "tw") {
                        url = `https://www.edrawsoft.com/zh-tw/edraw-project/?channel=${channel}`;
                    } else {
                        url = `https://www.edrawsoft.com/edraw-project/?channel=${channel}`;
                    }
                    this.sensors.track("clickProj", {
                        click_proj_way: "new",
                    });
                    break;
                case "board":
                    url = "https://boardmix.cn/?channel=max_new";
                    break;
                case "md":
                    url = "https://modao.cc/?channel=max_new";
                    break;
            }
            window.open(url);
        }

        get selectId() {
            return this.$store.state.selectId;
        }
        set selectId(value) {
            this.$store.commit("setState", { data: value, type: "selectId" });
        }
        get showTeamList() {
            return this.$store.state.showTeamList;
        }

        // 未登录可查模版社区
        get isNotLogin() {
            const hasUserInfo = this.userInfo && Object.keys(this.userInfo).length > 0;
            return !hasUserInfo;
        }

        clickSlider(id) {
            // 0 模版推荐 3 模版社区
            let canClickWhenNotLogin = (id === 3 || id === 0) && this.isNotLogin;

            if (!this.$validateLogin(!canClickWhenNotLogin) && !canClickWhenNotLogin) {
                return;
            }
            if (id === 3 && this.internal) {
                window.open("https://www.edrawmax.cn/templates/");
                return;
            }
            this.$store.commit("setState", { data: false, type: "showLoading" }); // 去除loadding动画
            this.$bus.$emit("closePreview"); // 关闭模板预览窗口
            this.$bus.$emit("closeUserWork"); // 关闭个人模板
            if (id === 21) {
                // this.showTeamList = !this.showTeamList;
                this.$store.commit("setState", { data: !this.showTeamList, type: "showTeamList" });
            }
            this.selectTeamId = 0;
            this.trackMenu(id);
            this.toMenu(id);
        }
        trackMenuMap = {
            0: "templaterecommendation",
            20: "recentlyopened",
            1: "mydocuments",
            22: "sharedwithme",
            21: "teamspace",
            3: "templatecommunity",
            4: "templatecollection",
            15: "edrawmaxacademy",
        };
        trackMenu(id) {
            this.sensors.track(this.trackMenuMap[id], {
                Catalogues: "myworkspace",
            });
        }
        cleanTeamId(str: string) {
            let temp = new URLSearchParams(str);
            temp.delete("id");
            return "?" + temp.toString();
        }
        cleanSearch(str: string) {
            if (this.$route.name == "SearchPage") {
                let temp = new URLSearchParams(str);
                temp.delete("search");
                temp.delete("type");
                return temp.toString();
            }
            return "?" + str;
        }
        toMenu(id, suffix = "") {
            let langStr = this.lang || appConfig.language;
            id != 2 && id != 15 && (this.selectId = id);
            let urlSearch = location.search;
            if (suffix) {
                if (urlSearch) {
                    urlSearch = /\?/.test(urlSearch) ? urlSearch + `&${suffix}` : urlSearch + `?${suffix}`;
                } else {
                    urlSearch = `?${suffix}`;
                }
            }
            urlSearch = this.cleanTeamId(urlSearch);
            urlSearch = this.cleanSearch(urlSearch);
            switch (id) {
                case 0: {
                    // 新建
                    this.$router.push(`/${langStr}/new${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 1: {
                    // 云文件
                    this.$router.push(`/${langStr}/workbench${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 3: {
                    // 社区模板
                    this.$router.push(`/${langStr}/store${urlSearch}`).catch((err) => {});
                    if (this.$route.name == "Store") {
                        // 刷新社区首页
                        if (!this.internal) {
                            this.$store.commit("setState", {
                                type: "templateSelect",
                                data: "index",
                            });
                        } else {
                            this.$store.commit("toTplCenter", {
                                name: "activeAlbumID",
                                data: -1,
                            });
                            this.$store.commit("toTplCenter", {
                                name: "albumPageStatus",
                                data: "default",
                            });
                        }
                    }
                    break;
                }
                case 4: {
                    // 我的收藏
                    this.$router.push(`/${langStr}/collect${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 8: {
                    // DropBox
                    let ts: any = this;
                    if (!ts.$checkAuth({ type: "dropbox" })) return;
                    this.$router.push(`/${langStr}/dropbox${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 22: {
                    this.$router.push(`/${langStr}/beshared${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 15: {
                    // 学堂
                    const url = "https://course.edrawsoft.cn/edrawmax";
                    window.open(url, "_blank");
                    break;
                }
                case 20: {
                    // 打开记录
                    this.$router.push(`/${langStr}/recent${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 21: {
                    // 新团队页面
                    this.$router.push(`/${langStr}/teams${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
            }
        }

        colors = ["#7D96B9", "#FF830F", "#FFC90E", "#24AF89", "#017FFF", "#4256D1"];
        get teams() {
            return this.$store.state.team.teams;
        }

        selectTeamId = 0;
        clickTeamItem(team) {
            this.clear();
            this.selectTeamId = team.id;
            let q = Object.assign({}, this.$route.query);
            q.id = team.id;
            this.$router.push({ path: "teams", query: q });
            this.$bus.$emit("clear");
        }

        tohome() {
            if (this.isPlugin) {
                return;
            }
            if (this.isPrivate || this.isTeamsApp) {
                location.reload();
                return;
            }
            let url = `${window.location.origin}/?stay=1`;
            let arr = ["es", "fr", "de", "it", "pt"];
            if (!this.internal) {
                if (this.lang == "jp") {
                    url = "https://www.edrawsoft.com/jp/tour/edrawmax.html";
                } else if (arr.includes(this.lang)) {
                    url = `${window.location.origin}/${this.lang}/?stay=1`;
                }
            }

            this.sensors.track("workBenchLogo", {
                Catalogues: "myworkspace",
            });
            window.open(url, "maxIndex");
        }

        mounted() {
            let pathName = this.$route.name.toLowerCase();
            if (pathName == "new") {
                this.selectId = 0;
            } else if (pathName == "workbench") {
                this.selectId = 1;
            } else if (pathName == "store") {
                this.selectId = 3;
            } else if (pathName == "collect") {
                this.selectId = 4;
            } else if (pathName == "teams") {
                this.selectId = 21;
                if (this.$route.query.id) {
                    this.selectTeamId = Number(this.$route.query.id);
                    // this.showTeamList = true;
                    this.$store.commit("setState", { data: true, type: "showTeamList" });
                }
            } else if (pathName == "beshared") {
                this.selectId = 22;
            } else if (pathName == "recent") {
                this.selectId = 20;
            }
            this.$bus.$on("changeOnlineSlide", (id) => {
                this.toMenu(id);
            });
            this.$bus.$on("jumpToCloud", (file) => {
                this.toMenu(1, `jump=${encodeURIComponent(JSON.stringify(file))}`);
            });
            this.$bus.$on("selectTeam", (id) => {
                if (this.$route.query.id) {
                    this.selectTeamId = Number(this.$route.query.id);
                    // this.showTeamList = true;
                    this.$store.commit("setState", { data: true, type: "showTeamList" });
                }
            });
            this.$bus.$on("jumpToEmpty", () => {
                this.addNewPage("empty");
            });
            this.$bus.$on("loginSucc", () => {
                this.$store.dispatch("getTeamList").then(() => {});
            });
        }

        created() {}
        beforeDestroy() {
            this.$bus.$off("changeOnlineSlide");
            this.$bus.$off("jumpToCloud");
            this.$bus.$off("jumpToEmpty", () => {
                this.addNewPage("empty");
            });
            this.$bus.$off("loginSucc");
        }
    }
</script>
<i18n>
    {
      "zh": {
        "new": "新建",
        "cloud": "我的文件",
        "team": "团队空间",
        "dropBox": "多宝箱",
        "google": "Google Drive",
        "import": "导入",
        "store": "模板社区",
        "collect": "模板收藏",
        "share": "我的分享",
        "trash": "回收站",
        "workbench": "我的工作台",
        "historyView": "历史浏览",
        "publishFile": "我的发布",
        "starFile": "收藏文件",
        "sharetome": "分享给我",
        "course": "亿图学堂",
        "openrecord": "最近打开",
        "login": "登录",
        "reg": "注册",
        "logout": "退出",
        "importSuccess": "导入成功",
        "isOpen": "是否立即打开？",
        "uploadFail": "上传失败，请重试",
        "space": "云空间已达上限， 删除文件或清理回收站",
        "cover": "提示",
        "isCover": "目标文件夹已存在同名文件，是否要覆盖？",
        "confirm": "覆盖",
        "openTips": "正在打开文件中，请稍后再试",
        "cancel": "不覆盖",
        "importOverLimit": "云文件超过限制，导入失败",
        "notSupportFile": "导入失败,不支持此文件类型",
        "dilatancy": "扩容",
        "newPage": "首页",
        "newFile": "未命名文件",
        "empty": "新建空文件",
        "flow": "流程图",
        "gantt": "甘特图",
        "uml": "UML图",
        "plan": "房屋平面图",
        "org": "架构图",
        "personal": "个人模板",
        "master": "亿图脑图",
        "project": "亿图项目管理",
        "board": "博思白板",
        "md": "墨刀原型",
        "moreTool": "更多工具",
        "rename": "重命名",
        "memberManage": "成员管理",
        "deleteSpace": "删除空间",
        "max": "亿图图示"
      },
      "en": {
        "new": "New",
        "cloud": "My Documents",
        "team": "Team",
        "dropBox": "Dropbox",
        "google": "Google Drive",
        "import": "Import",
        "store": "Templates",
        "collect": "Likes",
        "share": "Share",
        "trash": "Recycle Bin",
        "workbench": "Workbench",
        "historyView": "History",
        "publishFile": "Publish",
        "starFile": "Starred File",
        "sharetome": "Shared with me",
        "course": "Edraw Academy",
        "openrecord": "Recent",
        "login": "Login",
        "reg": "SignUp",
        "logout": "Logout",
        "importSuccess": "Import Completed",
        "isOpen": "Want to open it now?",
        "uploadFail": "Upload failed, please try again later.",
        "space": "Space storage not enough, delete files or upgrade to premium version to solve it.",
        "cover": "Tips",
        "isCover": "A file with the same name has already existed in the target folder，want to cover it?",
        "confirm": "Cover",
        "openTips": "Opening file, please try again later.",
        "cancel": "Cancel",
        "importOverLimit": "Importing failed, the amount of your flies has reached the upper limit.",
        "notSupportFile": "Importing failed, this file type is not supported",
        "dilatancy": "Expand Cloud Storage",
        "newPage": "Home Page",
        "newFile": "Unnamed File",
        "empty": "New blank file",
        "flow": "Flowchart",
        "gantt": "Gantt Charts",
        "uml": "UML Modeling",
        "plan": "Building Plan",
        "org": "Software Architecture",
        "personal": "Personal Template",
        "master": "EdrawMind",
        "project": "EdrawProj",
        "board": "Boardmix",
        "md": "Modao",
        "moreTool": "More Tools",
        "rename": "Rename",
        "memberManage": "Member Management",
        "deleteSpace": "Delete Space",
        "max": "EdrawMax"
      },
      "fr": {
        "new": "Nouveau",
        "cloud": "Mes documents",
        "team": "Équipes",
        "dropBox": "Dropbox",
        "google": "Google Drive",
        "import": "Importer",
        "store": "Communauté de modèles",
        "collect": "Mi piace",
        "share": "Ma part",
        "trash": "Corbeille",
        "workbench": "Mon établi",
        "historyView": "Navigation historique",
        "publishFile": "Publier",
        "starFile": "Fichier étoile",
        "sharetome": "Partage avec moi",
        "openrecord": "Récent",
        "login": "s'identifier",
        "reg": "inscrit",
        "logout": "Quitter",
        "importSuccess": "Importation réussie",
        "isOpen": "Voulez-vous l'ouvrir immédiatement?",
        "uploadFail": "Échec du téléchargement, veuillez réessayer",
        "space": "L'espace cloud a atteint la limite supérieure, supprimer des fichiers ou nettoyer la corbeille",
        "cover": "Astuces",
        "isCover": "Un fichier du même nom existe déjà dans le dossier cible. Voulez-vous le remplacer?",
        "confirm": "Couverture",
        "openTips": "Ouverture du fichier, veuillez réessayer plus tard",
        "cancel": "Ne pas couvrir",
        "importOverLimit": "Le fichier cloud dépasse la limite, l'importation échoue",
        "notSupportFile": "L'importation a échoué, ce type de fichier n'est pas pris en charge",
        "dilatancy": "Etendre l'espace de stockage du Cloud",
        "newPage": "Accueil",
        "newFile": "Fichier sans nom",
        "empty": "Nouveau",
        "flow": "Logigramme",
        "gantt": "Diagrammes de Gantt",
        "uml": "Modélisation UML",
        "plan": "Plan de construction",
        "org": "Organigramme",
        "personal": "Modèle personnel",
        "master": "EdrawMind",
        "project": "EdrawProj",
        "board": "Boardmix",
        "md": "Modao",
        "moreTool": "More Tools",
        "rename": "Renommer",
        "memberManage": "Gestion des membres",
        "deleteSpace": "Supprimer l'espace"
      },
      "de": {
        "new": "Neu",
        "cloud": "Eigene Dokumente",
        "team": "Team",
        "dropBox": "Dropbox",
        "google": "Google Drive",
        "import": "Importieren",
        "store": "Vorlagen-Community",
        "collect": "Me gusta",
        "share": "Mein Share",
        "trash": "Papierkorb",
        "workbench": "Meine Werkbank",
        "historyView": "Verlauf",
        "publishFile": "Veröffentlichen",
        "starFile": "Sternendatei",
        "sharetome": "Mit mir geteilt",
        "openrecord": "Kürzlich",
        "login": "Anmelden",
        "reg": "Registrieren",
        "logout": "Abmelden",
        "importSuccess": "Erfolgreich importiert",
        "isOpen": "Jetzt öffnen?",
        "uploadFail": "Upload fehlgeschlagen, bitte versuchen Sie es später erneut",
        "space": "Speicherplatz nicht ausreichend, Dateien löschen oder auf Premium-Version aktualisieren, um das Problem zu lösen",
        "cover": "Hinweis",
        "isCover": "Eine Datei mit demselben Namen ist bereits im Zielordner vorhanden. Möchten Sie sie ersetzen?",
        "confirm": "OK",
        "openTips": "Datei wird geöffnet. Versuchen Sie es später nch einmal",
        "cancel": "Abbrechen",
        "importOverLimit": "Import fehlgeschlagen, die Anzahl Ihrer Dateien hat die Obergrenze erreicht",
        "notSupportFile": "Import fehlgeschlagen, dieser Dateityp wird nicht unterstützt",
        "dilatancy": "Cloud-Speicher erweitern",
        "newPage": "Startseite",
        "newFile": "Unbenannte Datei",
        "empty": "Neu",
        "flow": "Flussdiagramm",
        "gantt": "Gantt- Diagramm",
        "uml": "UML- Diagramm",
        "plan": "Bauplan",
        "org": "Organigramm",
        "personal": "Persönliche Vorlage",
        "master": "EdrawMind",
        "project": "EdrawProj",
        "board": "Boardmix",
        "md": "Modao",
        "moreTool": "More Tools",
        "rename": "Umbenennen",
        "memberManage": "Mitgliederverwaltung",
        "deleteSpace": "Raum löschen"
      },
      "jp": {
        "new": "新規作成",
        "cloud": "マイドキュメント",
        "team": "チーム",
        "dropBox": "Dropbox",
        "google": "Google Drive",
        "import": "インポート",
        "store": "テンプレート",
        "collect": "いいね",
        "share": "共有",
        "trash": "ゴミ箱",
        "workbench": "ワークベンチ",
        "historyView": "閲覧履歴",
        "publishFile": "投稿",
        "starFile": "スターファイル",
        "sharetome": "自分と共有",
        "openrecord": "最近",
        "login": "ログイン",
        "reg": "登録",
        "logout": "ログアウト",
        "importSuccess": "インポートに成功しました",
        "isOpen": "すぐに開きますか？",
        "uploadFail": "アップロードできませんでした。もう一度お試しください",
        "space": "クラウドスペースが上限に達した、ファイルを削除、またはごみ箱をクリーンアップしてください",
        "cover": "ご注意",
        "isCover": "同じ名前のファイルがターゲットフォルダに既に存在します。上書きしますか？",
        "confirm": "確認",
        "openTips": "ファイルを開いています。しばらくしてからもう一度お試しください",
        "cancel": "キャンセル",
        "importOverLimit": "クラウドファイルが制限を超えているため、インポートは失敗します",
        "notSupportFile": "インポートに失敗しました。このファイル形式はサポートされていません",
        "dilatancy": "容量の追加",
        "newPage": "ホーム",
        "newFile": "名前のないファイル",
        "empty": "新着",
        "flow": "フローチャート",
        "gantt": "ガントチャート",
        "uml": "UML図",
        "plan": "間取り",
        "org": "組織図",
        "personal": "個人テンプレート",
        "master": "EdrawMind",
        "project": "EdrawProj",
        "board": "Boardmix",
        "md": "Modao",
        "moreTool": "More Tools",
        "rename": "名前を変更する",
        "memberManage": "メンバー管理",
        "deleteSpace": "スペースを削除する"
      },
      "es": {
        "new": "Nuevo",
        "cloud": "Mis documentos",
        "team": "equipo",
        "dropBox": "Dropbox",
        "google": "Google Drive",
        "import": "Importar",
        "store": "Comunidad",
        "collect": "Mentions J'aime",
        "share": "Compartir",
        "trash": "Papelera",
        "workbench": "Mi banco de trabajo",
        "historyView": "Historial",
        "publishFile": "Publicar",
        "starFile": "Estrellas archivos",
        "sharetome": "Compartidos conmigo",
        "openrecord": "Recientes",
        "login": "Iniciar sesión",
        "reg": "Regístrate",
        "logout": "Cerrar sesión",
        "importSuccess": "Importación completada",
        "isOpen": "¿Quieres abrirlo ahora?",
        "uploadFail": "Error al subir, intente nuevamente más tarde.",
        "space": "El espacio de almacenamiento no es suficiente, elimine archivos o actualice a la versión premium para resolverlo",
        "cover": "Consejos",
        "isCover": "Ya ha existido un archivo con el mismo nombre en la carpeta de destino, ¿quiere cubrirlo?",
        "confirm": "Comfirmar",
        "openTips": "Abriendo el archivo, por favor intente más tarde",
        "cancel": "Cancelar",
        "importOverLimit": "Error al importar, la cantidad de moscas ha alcanzado el límite superior",
        "notSupportFile": "Error al importar, este tipo de archivo no es compatible",
        "dilatancy": "Ampliar espacio en la nube",
        "newPage": "Inicio",
        "newFile": "Archivo sin nombre",
        "empty": "Nuevo",
        "flow": "Diagrama de Flujo",
        "gantt": "Diagramas de Gantt",
        "uml": "UML Modeling",
        "plan": "Plan de construcción",
        "org": "Organigrama",
        "personal": "Plantilla personal",
        "master": "EdrawMind",
        "project": "EdrawProj",
        "board": "Boardmix",
        "md": "Modao",
        "moreTool": "More Tools",
        "rename": "Renombrar",
        "memberManage": "Gestión de miembros",
        "deleteSpace": "Eliminar espacio"
      },
      "pt": {
        "new": "Novo",
        "cloud": "Meus documentos",
        "team": "times",
        "dropBox": "Dropbox",
        "google": "Google Drive",
        "import": "Importar",
        "store": "Comunidade de modelos",
        "collect": "Curtidas",
        "share": "Partilhar",
        "trash": "Pasta de Reciclagem",
        "workbench": "Minha bancada de trabalho",
        "historyView": "Navegação Histórica",
        "publishFile": "Publicar",
        "starFile": "Documentos Estrelados",
        "sharetome": "Compartilhado comigo",
        "openrecord": "Recente",
        "login": "Conectar",
        "reg": "Registrar-se",
        "logout": "Desconectar",
        "importSuccess": "Importação Concluída",
        "isOpen": "Deseja abrir agora?",
        "uploadFail": "Falha ao carregar, por favor, tentar mais tarde.",
        "space": "Espaço de armazenamento insuficiente, eliminar ficheiros ou fazer upgrade para a versão premium para resolver o problema.",
        "cover": "Dicas",
        "isCover": "Já existe um ficheiro com o mesmo nome na pasta de destino, deseja substituir o ficheiro?",
        "confirm": "OK",
        "openTips": "Abrindo ficheiro, por favor, tentar mais tarde.",
        "cancel": "Cancelar",
        "importOverLimit": "Falha ao importar, a quantidade de ficheiros atingiu o máximo superior.",
        "notSupportFile": "Falha ao importar, este tipo de ficheiro não é suportado",
        "dilatancy": "Expandir Armazenamento na Núvem",
        "newPage": "Início",
        "newFile": "Ficheiro Sem Nome",
        "empty": "Novo",
        "flow": "Fluxograma",
        "gantt": "Gráficos Gantt",
        "uml": "Modelação UML",
        "plan": "Planta",
        "org": "Gráfico Organizacional",
        "personal": "Modelo Pessoal",
        "master": "EdrawMind",
        "project": "EdrawProj",
        "board": "Boardmix",
        "md": "Modao",
        "moreTool": "More Tools",
        "rename": "Renomear",
        "memberManage": "Gestão de membros",
        "deleteSpace": "Excluir espaço"
      },
      "it": {
        "new": "Nuovo",
        "cloud": "I miei documenti",
        "team": "Squadre",
        "dropBox": "Dropbox",
        "google": "Google Drive",
        "import": "Importa",
        "store": "Comunità di modelli",
        "collect": "Preferiti",
        "share": "Condividi",
        "trash": "Cestino",
        "workbench": "Il mio banco da lavoro",
        "historyView": "Navigazione storica",
        "publishFile": "Pubblicare",
        "starFile": "File Stella",
        "sharetome": "Condividi con me",
        "openrecord": "Recenti",
        "login": "Accedi",
        "reg": "Registrati",
        "logout": "Esci",
        "importSuccess": "Importazione Completata",
        "isOpen": "Desideri aprirlo adesso?",
        "uploadFail": "Caricamento fallito. Si prega di riprovare più tardi.",
        "space": "Spazio di archiviazione insufficiente. Si prega di eliminare dei file o di eseguire l'upgrade alla versione premium.",
        "cover": "Suggerimenti",
        "isCover": "Esiste già un file con questo nome nella cartella di destinazione. Desideri sostituirlo?",
        "confirm": "OK",
        "openTips": "Apertura file in corso. Si prega di riprovare.",
        "cancel": "Annulla",
        "importOverLimit": "Importazione fallita. Il numero di file ha raggiunto il limite massimo.",
        "notSupportFile": "Importazione fallita. Tipo di file non supportato.",
        "dilatancy": "Espandi l'Archiviazione di Cloud",
        "newPage": "Home",
        "newFile": "File Senza Nome",
        "empty": "Nuovo",
        "flow": "Diagramma di Flusso",
        "gantt": "Diagrammi di Gantt",
        "uml": "Modeling UML",
        "plan": "Piano Edificio",
        "org": "Grafico Organizzativo",
        "personal": "Modello Personale",
        "master": "EdrawMind",
        "project": "EdrawProj",
        "board": "Boardmix",
        "md": "Modao",
        "moreTool": "More Tools",
        "rename": "Rinomina",
        "memberManage": "Gestione dei membri",
        "deleteSpace": "Elimina spazio"
      },
      "tw": {
        "new": "新建空白模板",
        "cloud": "我的文件",
        "team": "團隊",
        "dropBox": "Dropbox",
        "google": "Google Drive",
        "import": "導入",
        "store": "模板社區",
        "collect": "喜愛項目",
        "share": "我的分享",
        "trash": "回收站",
        "workbench": "我的工作台",
        "historyView": "歷史瀏覽",
        "publishFile": "發佈",
        "starFile": "星標檔案",
        "sharetome": "與我共用",
        "openrecord": "最近",
        "login": "登入",
        "reg": "註冊",
        "logout": "登出",
        "importSuccess": "導入成功",
        "isOpen": "是否立即打開？",
        "uploadFail": "上傳失敗，請重試",
        "space": "雲端硬碟已達上限， 刪除檔案或清理回收站",
        "cover": "提示",
        "isCover": "目標資料夾已存在同名檔案，是否要覆蓋？",
        "confirm": "覆蓋",
        "openTips": "正在打開檔案中，請稍後再試",
        "cancel": "不覆蓋",
        "importOverLimit": "雲端硬碟檔案超過限制，導入失敗",
        "notSupportFile": "導入失敗,不支持此檔案類型",
        "dilatancy": "擴充雲端硬碟儲存空間",
        "newPage": "推薦",
        "newFile": "未命名檔案",
        "empty": "新建空文件",
        "flow": "流程圖",
        "gantt": "甘特圖",
        "uml": "UML圖",
        "plan": "平面圖",
        "org": "组织圖",
        "personal": "个人模板",
        "master": "EdrawMind",
        "project": "EdrawProj",
        "board": "Boardmix",
        "md": "Modao",
        "moreTool": "More Tools",
        "rename": "重命名",
        "memberManage": "成员管理",
        "deleteSpace": "删除空间"
      },
      "kr": {
        "new": "새로 만들기",
        "cloud": "내 문서",
        "team": "팀",
        "dropBox": "Dropbox",
        "google": "Google Drive",
        "import": "가져오기",
        "store": "템플릿 갤러리",
        "collect": "좋아요",
        "share": "공유",
        "trash": "휴지통",
        "workbench": "워크벤치",
        "historyView": "조회 기록",
        "publishFile": "게시한 파일",
        "starFile": "별표 파일",
        "sharetome": "나에게 공유됨",
        "openrecord": "최근",
        "login": "로그인",
        "reg": "가입",
        "logout": "로그아웃",
        "importSuccess": "가져오기 성공",
        "isOpen": "지금 열겠습니까？",
        "uploadFail": "업로드 실패, 다시 시도하세요.",
        "space": "클라우드 공간이 상한에 도달했습니다. 파일을 삭제하거나 휴지통을 청소하세요~",
        "cover": "팁",
        "isCover": "동일한 이름의 파일이 대상 폴더에 이미 있습니다. 덮어 쓰시겠습니까?",
        "confirm": "덮어쓰기",
        "openTips": "파일을 여는 중입니다. 나중에 다시 시도하세요~",
        "cancel": "덮어쓰지 않기",
        "importOverLimit": "클라우드 파일이 제한을 초과하여 가져 오기에 실패했습니다",
        "notSupportFile": "가져 오기에 실패했습니다.이 파일 형식은 지원되지 않습니다.",
        "dilatancy": "클라우드 스토리지 확장",
        "newPage": "추천",
        "newFile": "이름이없는 파일",
        "empty": "새 템플릿 만들기",
        "flow": "순서도",
        "gantt": "간트차트",
        "uml": "UML도",
        "plan": "평면도",
        "org": "조직구조도",
        "personal": "개인 템플릿",
        "master": "EdrawMind",
        "project": "EdrawProj",
        "board": "Boardmix",
        "md": "Modao",
        "moreTool": "More Tools",
        "rename": "이름 바꾸기",
        "memberManage": "회원 관리",
        "deleteSpace": "공간 삭제"
      },
      "id": {
        "new": "Baru",
        "cloud": "Dokumen Saya",
        "team": "Tim",
        "dropBox": "Dropbox",
        "google": "Google Drive",
        "import": "Impor",
        "store": "Templat",
        "collect": "Favorit",
        "share": "Bagikan",
        "trash": "Tempat Sampah",
        "workbench": "Meja kerja",
        "historyView": "Riwayat",
        "publishFile": "Terbitkan",
        "starFile": "File Berbintang",
        "sharetome": "Bagikan dengan saya",
        "openrecord": "Terbaru",
        "login": "Masuk",
        "reg": "Daftar",
        "logout": "Keluar",
        "importSuccess": "Impor Selesai",
        "isOpen": "Ingin membukanya sekarang?",
        "uploadFail": "Gagal mengunggah. Coba lagi nanti.",
        "space": "Ruang penyimpanan tidak cukup. Hapus file atau tingkatkan ke versi premium untuk mengatasinya.",
        "cover": "Tip",
        "isCover": "File dengan nama yang sama sudah ada di folder target. Ingin menimpanya?",
        "confirm": "Timpa",
        "openTips": "Membuka file. Coba lagi nanti.",
        "cancel": "Batalkan",
        "importOverLimit": "Gagal mengimpor. Jumlah file telah melebihi batas.",
        "notSupportFile": "Gagal mengimpor. Jenis file ini tidak didukung",
        "dilatancy": "Tingkatkan Penyimpanan Cloud",
        "newPage": "Beranda",
        "empty": "Baru",
        "flow": "Bagan Alur",
        "gantt": "Bagan Gantt",
        "uml": "Pemodelan UML",
        "plan": "Rencana Pembangunan",
        "org": "Bagan Organisasi",
        "personal": "Templat Pribadi",
        "master": "EdrawMind",
        "project": "EdrawProj",
        "board": "Boardmix",
        "md": "Modao",
        "moreTool": "More Tools"
      }
    }
    </i18n>
